import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background: #f7f8fa;
`;

export const Content = styled.main`
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
  padding: 64px 20px;
`;

export const Hero = styled.section`
  margin-bottom: 1.5rem;

  h1 {
    margin: 0;
    color: #0e2244;
    font-size: 2rem;
    line-height: 1.2;
  }

  p {
    margin-top: 0.75rem;
    margin-bottom: 0;
    color: #4e4d4d;
    font-size: 0.95rem;
  }
`;

export const PolicyCard = styled.section`
  padding: 0;

  h2 {
    color: #0e2244;
    font-size: 1.3rem;
    margin: 0 0 1.2rem;
  }

  h3 {
    color: #0e2244;
    font-size: 1.05rem;
    margin: 1.25rem 0 0.6rem;
  }

  p {
    margin: 0.5rem 0;
    color: #4e4d4d;
    line-height: 1.6;
    font-size: 0.98rem;
    text-align: justify;
  }

  ul {
    margin: 0.6rem 0;
    padding-left: 1.2rem;
  }

  li {
    color: #4e4d4d;
    line-height: 1.6;
    margin: 0.4rem 0;
  }

  a {
    color: #0e2244;
    font-weight: 600;
    text-decoration: underline;
  }

  span p {
    text-align: right;
  }

  .strong {
    font-weight: bold;
  }
`;
